import { put, call } from 'redux-saga/effects'

function* fetchService(service, actions = {}) {
  yield put(actions.request())
  try {
    const result = yield call(service)
    yield put(actions.success(result))
  } catch (err) {
    console.log(err)
    yield put(actions.error(err))
  }
}

export default fetchService
